import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "@vilocnv/allsetra-core";
import i18n from "i18next";
import { getRideHistory } from "domain/rides/api/get-ride-history";
import { RideHistoryRequestDto } from "domain/rides/entities/dtos/ride-history.dto";

/**
 * The statuses the backend settled on (aligned 2026-09-22): 404 covers both an
 * unknown ride and one the user may not see, so it is phrased as a privacy
 * restriction; an account without the feature answers 402, and anything else
 * is a plain failure.
 */
const describeFailure = (status?: number) => {
  if (status === 404) {
    return {
      message: "toasts.rideHistoryPrivacy",
      toastId: "rides/rideHistoryPrivacy"
    };
  }

  if (status === 402) {
    return {
      message: "toasts.rideHistoryDisabled",
      toastId: "rides/rideHistoryDisabled"
    };
  }

  return {
    message: "toasts.getRideHistoryError",
    toastId: "rides/getRideHistoryError"
  };
};

const getRideHistoryAction = createAsyncThunk(
  "rides/getRideHistoryAction",
  async (request: RideHistoryRequestDto, thunkAPI) => {
    try {
      return await getRideHistory(request);
    } catch (error: any) {
      console.error(error);

      const { message, toastId } = describeFailure(error?.response?.status);

      // The id keeps a repeated failure to one toast: react-toastify drops a
      // second toast whose id is already on screen.
      toast.error(i18n.t(message), { toastId });

      return thunkAPI.rejectWithValue(error);
    }
  }
);

export default getRideHistoryAction;
